import { Controller } from "@hotwired/stimulus";

// Controller: schedule-days
// Targets:
// - allTime: the master "all_time" checkbox
// - day: the individual weekday checkboxes
// Behavior:
// Selecting the all_time checkbox clears (unchecks) all weekday checkboxes.
// Selecting any weekday checkbox clears (unchecks) the all_time checkbox.
export default class extends Controller {
  static targets = ["allTime", "day"]; // data-schedule-days-target="allTime" / "day"

  selectNone(event) {
    // Only act when checked; if user unchecks, leave days untouched
    if (this.allTimeTarget.checked) {
      this.dayTargets.forEach((cb) => {
        if (cb.checked) {
          cb.checked = false;
          // Fire change so any other listeners/UI (like Semantic UI) update
          cb.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }

  resetSelect(event) {
    const checked = event.target.checked;
    // If any day is interacted with, ensure all_time is off
    if (checked && this.hasAllTimeTarget && this.allTimeTarget.checked) {
      this.allTimeTarget.checked = false;
      this.allTimeTarget.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}
